import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PreviewInstructions from "./Components/PreviewInstructions";

const PLAYER_COLUMNS = [
  { key: "playerOne", label: "Person 1", color: "#3f51b5", groupOnly: false },
  { key: "playerTwo", label: "Person 2", color: "#4caf50", groupOnly: false },
  { key: "playerThree", label: "Person 3", color: "#9c27b0", groupOnly: true },
  { key: "playerFour", label: "Person 4", color: "#009688", groupOnly: true },
];

const AssignmentSection = ({ title, assignedLyrics, lines, currentLine, isGroupMode }) => {
  const visibleColumns = PLAYER_COLUMNS.filter(
    (col) => !col.groupOnly || isGroupMode
  ).filter((col) => (assignedLyrics[col.key] || []).length > 0);

  const sections = [
    ...visibleColumns.map((col) => ({
      key: col.key,
      label: col.label,
      color: col.color,
      lines: assignedLyrics[col.key] || [],
    })),
    ...(assignedLyrics.bothPlayers.length > 0
      ? [{
          key: "bothPlayers",
          label: isGroupMode ? "All" : "Together",
          color: "#de7e09",
          lines: assignedLyrics.bothPlayers,
        }]
      : []),
  ];

  if (sections.length === 0) return null;

  return (
    <Box width="100%" mb={4}>
      <Typography className="commandsTitle" sx={{ fontWeight: 600, fontSize: "18px", mb: 2, textAlign: "center" }}>
        {title}
      </Typography>
      <Box
        display="flex"
        gap={2}
        width="100%"
        alignItems="stretch"
        sx={{ overflowX: "auto" }}
      >
        {sections.map((section, index) => (
          <React.Fragment key={section.key}>
            {index > 0 && (
              <Divider orientation="vertical" flexItem sx={{ borderColor: "gray.400" }} />
            )}
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              overflow="auto"
              flex={1}
              minWidth="140px"
            >
              <Typography fontSize="16px" color={section.color} display="flex" alignItems="center">
                <PersonIcon fontSize="small" sx={{ color: section.color, mr: 1 }} />
                {section.label}
              </Typography>
              <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
                {section.lines.map((lineIndex) => (
                  <Typography
                    key={lineIndex}
                    variant="body1"
                    color={lineIndex === currentLine ? section.color : "text.secondary"}
                    className={`line-${section.key}-${lineIndex}`}
                    mb={1}
                    sx={{
                      padding: "4px",
                      backgroundColor:
                        lineIndex === currentLine ? `${section.color}1a` : "transparent",
                      borderRadius: "4px",
                    }}
                  >
                    {lines[lineIndex]}
                  </Typography>
                ))}
              </Box>
            </Box>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

const LyricsPreview = ({
  soloAssignedLyrics,
  groupAssignedLyrics,
  lines,
  currentLine,
}) => (
  <Box display="flex" flexDirection="column" alignItems="center" width="100%">
    <PreviewInstructions
      soloAssignedLyrics={soloAssignedLyrics}
      groupAssignedLyrics={groupAssignedLyrics}
    />
    <Box width="100%" sx={{ maxHeight: "calc(100vh - 320px)", overflowY: "auto" }}>
      <AssignmentSection
        title="Solo lyrics"
        assignedLyrics={soloAssignedLyrics}
        lines={lines}
        currentLine={currentLine}
        isGroupMode={false}
      />
      <AssignmentSection
        title="Group lyrics"
        assignedLyrics={groupAssignedLyrics}
        lines={lines}
        currentLine={currentLine}
        isGroupMode
      />
    </Box>
  </Box>
);

export default LyricsPreview;
